import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import agent from "../api/agent";
import { PrintEntry } from "../models/printEntry";
import CenteredCard from "../layout/CenteredCard";

export default function QRCodeScreen() {
  const { id } = useParams<{ id: string }>();
  const [printEntry, setPrintEntry] = useState<PrintEntry | null>(null);

  const fetchPrintEntry = async () => {
    if (id) {
      try {
        const fetchedPrintEntry = await agent.PrintEntries.details(id);
        setPrintEntry(fetchedPrintEntry);
      } catch (error) {
        console.error("Failed to fetch print entry:", error);
      }
    } else {
      console.error("No print entry id provided");
    }
  };

  useEffect(() => {
    fetchPrintEntry();
  }, [id]);

  if (!printEntry) {
    return <CenteredCard>Yükleniyor...</CenteredCard>;
  }

  return (
    <>
      <main
        lang="az"
        className="print-gift-screen"
        style={{
          background: `url(${process.env.PUBLIC_URL}/assets/birbank-logo.png) 28px 15px no-repeat, url(${process.env.PUBLIC_URL}/assets/baskitasarim-bg.jpg) center center no-repeat`,
          backgroundSize: '250px 38px, cover'
        }}
      >
        <div className="wizard-step single">
          <h3>{printEntry.name}</h3>

          {printEntry.hasPicked ? (
            <>
              <p className="success-message">Hədiyyənizi almaq üçün kodunuz</p>
              <h1 className="code">{printEntry.receivingCode}</h1>
              <small>Lütfən, bu səhifənin ekran görüntüsünü yadda saxlayın və ya hədiyyənizi alana qədər bu tabı bağlamayın.</small>
            </>
          ) : (
            <>
              <p className="success-message">Siz hələ hədiyyə seçiminizi etməmisiniz. Seçiminizi etdikdən sonra bu səhifəyə qayıdın.</p>
            </>
          )}
        </div>
      </main>
    </>
  );
}